import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useMemo, useState } from 'react';
import { ITimeBlockListing } from '../../../../entities-generated/models/time-block/time-block-listing';
import { partition } from '../../../../framework/utils/collection';
import { InstallationDateListing } from './listing';
import { BwjLinkButton } from '../../../../framework/components/bwj-link-button';

interface IInstallationDateSelectorProps {
  value: ITimeBlockListing | null | undefined;
  options: ITimeBlockListing[];
  onTimeSelected: (time: ITimeBlockListing) => void;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: 0,
    margin: '1rem auto',
    width: '100%',
    boxSizing: 'border-box',
    maxWidth: 700,
  };

  const buttonContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 0,
  };

  return mergeStyleSets({
    root,
    buttonContainer,
  });
}

export const InstallationDateSelector: React.FunctionComponent<IInstallationDateSelectorProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { options } = props;
  const [pageIndex, setPageIndex] = useState(0);
  const pages = useMemo(() => partition(options, 5), [options]);
  const displayOptions = useMemo(() => pages.slice(0, pageIndex + 1).flatMap(p => p), [pages, pageIndex]);

  return (
    <div className={cs.root}>
      {displayOptions.map(listing =>
       <InstallationDateListing
        selected={listing === props.value}
        timeBlock={listing}
        onSelected={props.onTimeSelected}
       /> 
      )}
      {<div className={cs.buttonContainer}>
        <BwjLinkButton
          text={'Show more dates'}
          icon={'CalendarWorkWeek'}
          onClick={() => setPageIndex(pageIndex + 1)}
        />
      </div>}
    </div>
  );
};
